module.exports = __webpack_public_path__ + "img/example.b02f26d1.jpg";